<span class="button-loader" [style.border]="borderStyle"></span>